// @flow
import { styled, withStyle } from 'mz-ui-kit'
import { getScreenStyles } from '../../../utils'
import {
  Container as BasicContainer,
  ExistingLabel,
} from '../CreditCardItem/elements'

export const Container = withStyle(BasicContainer, {
  display: 'block',
})

// Container for the secure iframe
export const IframeContainer = styled<{
  $mobile?: boolean,
}>('iframe', ({ $mobile }) => ({
  border: 'none',
  outline: 'none',
  width: $mobile ? '100%' : '600px',
  height: $mobile ? '100%' : '600px',
}))

export const HeaderLabel = withStyle<typeof ExistingLabel, {}>(
  ExistingLabel,
  ({ $palette }) => ({
    color: `${$palette('text')}`,
    display: 'flex',
    alignItems: 'center',
    ...getScreenStyles(
      'xs',
      {
        flexFlow: 'row wrap',
        padding: '0px 15px 0px 0px',
      },
      {
        flexFlow: 'row nowrap',
        padding: '5px 15px 5px 0px',
      }
    ),
  })
)

export const HeaderText = styled('div', {
  marginRight: '10px',
})

export const ExtraFieldsContainer = styled('div', {
  ':first-child': {
    marginTop: '20px',
  },
  ':not(:first-child)': {
    marginTop: '10px',
  },
})

export const WarningMessage = styled<{}>('div', ({ $palette }) => ({
  marginTop: '8px',
  color: `${$palette('YELLOW').darken(20)}`,
  fontSize: '0.857em',
}))

export const CardIcons = styled('div', {
  display: 'flex',
  flexFlow: 'row wrap',
  fontSize: '18px',
})

export const CardIconWrapper = styled('div', {
  marginTop: '2px',
  marginBottom: '2px',
  ':not(:last-child)': {
    marginRight: '5px',
  },
})
